import React, { Fragment, useState, useEffect } from 'react'
import ReactDOM from 'react-dom';
import './index.scss';
import '@asseinfo/react-kanban/dist/styles.css'
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom'
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
// import { configureFakeBackend } from './services/fack.backend'
import "./i18n";
import Loader from "./layout/loader";
import ErrorBoundary from './utilities/ErrorBoundary';
import ApplicationRoutes from './route/ApplicationRoutes';
import { getFromLocalStorage, setInLocalStorage } from './hooks/useLocalStorage';
import { localStorageVar } from './constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { logoutUser } from './api';
import Logins from './auth/signin';
import GlobalPaymentListener from './components/GlobalPaymentListener';
// setup fake backend
// configureFakeBackend();
// setup dotenv

// require('dotenv').config()
// setup dotenv

require('dotenv').config()

const Root = (props) => {
  /* eslint-disable */
  const [modalIsOpen, setModalIsOpen] = useState(false);
  // const dispatch = useDispatch();

  useEffect(() => {
    const language = getFromLocalStorage(localStorageVar.LANG_VAR)
    const languageI18 = getFromLocalStorage(localStorageVar.I18_LANG_VAR)
    if (language == null || languageI18 == null) {
      setInLocalStorage(localStorageVar.LANG_VAR, 'English')
      setInLocalStorage(localStorageVar.I18_LANG_VAR, 'English')
    }
  }, [])


  const handleOnIdle = () => {
    const token = getFromLocalStorage(localStorageVar.TOKEN_VAR)
    if (token !== null && token.length > 0) {
      // setModalIsOpen(true);
      // setTimeout(() => {
      //   setModalIsOpen(false);
      // }, 15000);
      toast.info("Session timed out")
      logoutUser()
    }
    // else{
    //   setModalIsOpen(false);
    // }
  };

  return (
    <Fragment>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          {/* <GoogleOAuthProvider
            clientId={process.env.REACT_APP_CLIENT_SECRET || "421635888645-btg5f7vrlvrp1g17vcnsla9d80ecijq3.apps.googleusercontent.com"}
          > */}
          <Router basename={`/`}>
            <Routes>
              {/* <Route path="/" element={<ComingsoonImg />} /> */}
              <Route path="/" element={<Logins />} />
            </Routes>
            <ErrorBoundary>
              <ApplicationRoutes />
              {/* {modalIsOpen && <CustomModal isOpen={modalIsOpen} onRequestClose={null} setModalIsOpen={setModalIsOpen} /> }  */}
              {/* <Idle timeout={1000*60*15} onChange={handleOnIdle} /> */}
            </ErrorBoundary>
          </Router>
          {/* </GoogleOAuthProvider> */}
          <GlobalPaymentListener />
        </PersistGate>
      </Provider>
      <ToastContainer />
    </Fragment>



  )
}

ReactDOM.render(<Root />,
  document.getElementById('root')
);

serviceWorker.unregister();
